<div [ngClass]="geefIconCssClass()" [class.ols-has-icon]="icon">
    <div *ngIf="icon && iconFromSpriteOrFont()" [ngClass]="geefClassSprite()"></div>
    <img *ngIf="icon && !iconFromSpriteOrFont()" [src]="iconlocation()" />
</div>